import Configs from '../../../../src/vendorConfigs/Configs';
import { Tween } from '../../Tween';
import GameModel from '../../model/GameModel';
import SpinModel from '../../model/SpinModel';
import { DefaultLayers } from '../../utils/Layers';
import ViewManager from '../../utils/ViewManager'
import CascadeReelGroup from '../../views/CascadeReelGroup';
import { State } from '../State';
export default class CascadeFillExplodedState extends State {

    protected reelGroup: CascadeReelGroup;
    /**
     * Value must be in ms
     */
    protected delayToExit: number = 100;
    public enter(): void {
        super.enter();
        this.init();
    }
    /**
     * Put here all logic called after enter of the state
     */
    protected init(): void {
        this.reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as CascadeReelGroup;

        this.reelGroup.fillExplodes();
        // Set up delay to exit
        this.setExitDelayTween();
        // Increment cascade index
        this.triggerNextCascade();
    }
    /**
     * Increment cascade index in SpinModel
     */
    protected triggerNextCascade() {
        SpinModel.cascadeIndex++;
    }

    /**
     * Set up a delay call tween for exit of this state
     */
    protected setExitDelayTween(): void {
        Tween.delayedCall(this.getStateDuration(), () => this.exit())
    }

    /**
     * @returns Duration time in this state in seconds (1000ms = 1s)
     */
    protected getStateDuration(): number {
        return (this.getExitDelay() + this.getFillExplodedAnimationDuration()) / 1000
    }
    /**
     * @returns Delay for exit of the state after animations complete in seconds (1000ms = 1s)
     */
    protected getExitDelay(): number {
        return this.delayToExit
    }
    /**
     * @returns Duration time needed to explode all symbols in ms (1000ms = 1s)
     */
    protected getFillExplodedAnimationDuration(): number {
        // Animation time to fill exploded symbols
        let result = 0;
        const explodeMapCount = SpinModel.getCurrentCascadeExplodeMap().reduce((acc, r) => {
            (r as []).forEach(v => v ? acc += 1 : null);
            return acc
        }, 0);

        if (Configs?.reels?.cascadeProps?.dropRemainingProps) {
            if (GameModel.turboSpin) {
                result = explodeMapCount * Configs.reels.cascadeProps.dropRemainingProps.delayInTurbo + Configs.reels.cascadeProps.dropRemainingProps.animationDurationInTurbo;
            } else {
                result = explodeMapCount * Configs.reels.cascadeProps.dropRemainingProps.delay + Configs.reels.cascadeProps.dropRemainingProps.animationDuration;
            }
        }


        return result
    }
}
